import { ProductPrice } from '@msdyn365-commerce/retail-proxy';

export const getOriginalPrice = (price: ProductPrice): number => {
    return price?.AdjustedPrice ?? price?.TradeAgreementPrice ?? price?.BasePrice ?? 0;
};

export const getActivePrice = (price: ProductPrice): number => {
    if (price?.CustomerContextualPrice !== undefined) {
        return price?.CustomerContextualPrice ?? 0;
    }

    return getOriginalPrice(price);
};

export const isFreePrice = (price: ProductPrice): boolean => {
    return getActivePrice(price) === 0;
};
